import "./App.css";
import NavBar from "./components/navbar/NavBar";
import PlayGround from "./components/playground/PlayGround";

function App() {
  return (
    <>
      <NavBar />
      <PlayGround />
    </>
  );
}

export default App;
